import { MemberTableSubject } from "@components/common/faro-table/faro-table-types";
import { useAppDispatch } from "@store/store-helper";
import { setTableType } from "@store/table/table-slice";
import { TableType } from "@utils/track-event/track-event-list";
import { useEffect } from "react";

/**
 * Sets the correct table type in Redux based on the member table subject.
 * Used by both MembersTable and MembersMobileView to keep table state consistent.
 */
export function useSetMemberTableType(tableSubject: MemberTableSubject): void {
  const dispatch = useAppDispatch();

  useEffect(() => {
    switch (tableSubject) {
      case "workspace":
        dispatch(setTableType(TableType.companyMembers));
        break;

      case "project":
        dispatch(setTableType(TableType.projectMembers));
        break;

      case "group":
        dispatch(setTableType(TableType.groupMembers));
        break;

      case "team":
        dispatch(setTableType(TableType.teamMembers));
        break;

      case "activeMembers":
        dispatch(setTableType(TableType.activeMembers));
        break;
    }
  }, [tableSubject, dispatch]);
}
